<script setup >
import { RouterLink, RouterView } from 'vue-router'
// 汉化
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
dayjs.locale('zh-cn');
import 'dayjs/locale/zh-cn';
import { storeToRefs, } from 'pinia';
import { useCounterStore } from '@/stores/counter'
const $state=useCounterStore()
const { 
  spinning
}  = storeToRefs($state)
</script>

<template>
      <a-config-provider :locale="zhCN">
        <RouterView />
      </a-config-provider>
      <div class="modelspin" v-if="spinning">
        <div>
          <a-spin size="large" tip="加载中..."/>
        </div>
      </div>
</template>

<style scoped lang="scss">
.app{
  height: 100%;
  width:100%;
}
.modelspin{
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 2000;
  top: 0;
  left: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  >div:nth-child(1){
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
